
    import './styles.scoped.css';
    export default {
  "breadcrumb-group": "awsui_breadcrumb-group_d19fg_nj58d_9",
  "breadcrumb-group-list": "awsui_breadcrumb-group-list_d19fg_nj58d_44",
  "ghost": "awsui_ghost_d19fg_nj58d_55",
  "item": "awsui_item_d19fg_nj58d_60",
  "ghost-item": "awsui_ghost-item_d19fg_nj58d_61",
  "ellipsis": "awsui_ellipsis_d19fg_nj58d_62",
  "hide": "awsui_hide_d19fg_nj58d_73",
  "visible": "awsui_visible_d19fg_nj58d_79",
  "icon": "awsui_icon_d19fg_nj58d_83",
  "breadcrumbs-skeleton": "awsui_breadcrumbs-skeleton_d19fg_nj58d_89",
  "collapsed-button": "awsui_collapsed-button_d19fg_nj58d_93",
  "button-icon": "awsui_button-icon_d19fg_nj58d_175",
  "button-icon-open": "awsui_button-icon-open_d19fg_nj58d_189",
  "hidden": "awsui_hidden_d19fg_nj58d_193"
};
  